import { v4 as uuidv4 } from 'uuid';

const state = {
  // Store templates in an object keyed by intervention_id
  // Format: { interventionId: [template1, template2], ... }
  templatesByIntervention: {},
};

const getters = {
  // This getter returns a function, allowing us to pass the interventionId
  templatesByInterventionId: (state) => (interventionId) => {
    return state.templatesByIntervention[interventionId] || [];
  },
};

const mutations = {
  ADD_TEMPLATE(state, { interventionId, newTemplate }) {
    // If this is the first template for this intervention, initialize an empty array
    if (!state.templatesByIntervention[interventionId]) {
      // Use Vue.set or object spread to ensure reactivity
      state.templatesByIntervention = {
        ...state.templatesByIntervention,
        [interventionId]: [],
      };
    }
    state.templatesByIntervention[interventionId].push(newTemplate);
  },
  DELETE_TEMPLATE(state, { interventionId, templateId }) {
    if (state.templatesByIntervention[interventionId]) {
      state.templatesByIntervention[interventionId] = state.templatesByIntervention[interventionId].filter(
        (template) => template.id !== templateId
      );
    }
  },
  UPDATE_TEMPLATE(state, { interventionId, templateId, content }) {
    if (state.templatesByIntervention[interventionId]) {
      const templateIndex = state.templatesByIntervention[interventionId].findIndex(
        (template) => template.id === templateId
      );
      if (templateIndex !== -1) {
        // To ensure reactivity, we should replace the object
        const updatedTemplate = {
          ...state.templatesByIntervention[interventionId][templateIndex],
          content,
        };
        state.templatesByIntervention[interventionId].splice(templateIndex, 1, updatedTemplate);
      }
    }
  },
};

const actions = {
  addTemplate({ commit }, { interventionId, name, content = {} }) {
    if (!interventionId) {
      console.error("interventionId is required to add a template.");
      return;
    }
    const newTemplate = {
      id: uuidv4(), // Use uuid to ensure unique IDs
      name,
      content, // Add content to the template object
    };
    commit('ADD_TEMPLATE', { interventionId, newTemplate });
  },
  deleteTemplate({ commit }, { interventionId, templateId }) {
    if (!interventionId) {
      console.error("interventionId is required to delete a template.");
      return;
    }
    commit('DELETE_TEMPLATE', { interventionId, templateId });
  },
  updateTemplate({ commit }, { interventionId, templateId, content }) {
    if (!interventionId || !templateId) {
      console.error("interventionId and templateId are required to update a template.");
      return;
    }
    commit('UPDATE_TEMPLATE', { interventionId, templateId, content });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
